import { render, staticRenderFns } from "./manage-chapter.vue?vue&type=template&id=2b514ecf&scoped=true"
import script from "./manage-chapter.ts?vue&type=script&lang=ts&external"
export * from "./manage-chapter.ts?vue&type=script&lang=ts&external"
import style0 from "./manage-chapter.less?vue&type=style&index=0&id=2b514ecf&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b514ecf",
  null
  
)

export default component.exports